// CurriculumBanner.jsx
import React from 'react';
import styled from 'styled-components';
import MyInfoBanner from '../../assets/image/myinfo_ciricullum_banner.png';

const breakpoints = {
  tablet: 768,
  phone:  480,
};

const BannerContainer = styled.div`
  width: 100%;
  margin: 10px 0;
  text-align: center;

  @media (max-width: ${breakpoints.tablet}px) {
    margin: 14px 0;
  }

  @media (max-width: ${breakpoints.phone}px) {
    margin: 12px 0;
  }
`;

const BannerLink = styled.a`
  display: block;
`;

const BannerImage = styled.img`
  width: 100%;
  height: auto;
  border: none;

  /* slightly narrower on tablets */
  @media (max-width: ${breakpoints.tablet}px) {
    width: 100%;
  }

  /* much narrower on phones */
  @media (max-width: ${breakpoints.phone}px) {
    width: 100%;
  }
`;

const CurriculumBanner = ({ curriculumLink }) => {
  const resolvedLink = curriculumLink ?? null;
  return (
    <BannerContainer>
      <BannerLink href={resolvedLink} target="_blank" rel="noopener noreferrer">
        <BannerImage
          src={MyInfoBanner}
          alt="Curriculum Download Process Banner"
        />
      </BannerLink>
    </BannerContainer>
  );
};

export default CurriculumBanner;
